export default "__VITE_ASSET__baY2dWfB__"